import { render, staticRenderFns } from "./TranscriptRecord.vue?vue&type=template&id=a9617afc&scoped=true"
import script from "./TranscriptRecord.vue?vue&type=script&lang=js"
export * from "./TranscriptRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9617afc",
  null
  
)

export default component.exports